/*
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-06-22 13:34:31
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-06-24 14:30:13
 * @FilePath: \vysa_wifi_web\src\api\index.ts
 * @Description: api
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import { https } from "@/request";

export const getWifiLoginAuth = (data: any, pagePath?: string) =>
  pagePath
    ? https.post(`/wifi/login/auth/${data}`, {}, { params: { path: pagePath } })
    : https.post(`/wifi/login/auth/${data}`);
export const postWxconfigData = (data: any) =>
  https.post("/wifi/login/getJsSignature", data);

export const getWifiCustomizationCardQueryCardMsg = (params: any) =>
  https.get("/wifi/customization/card/queryCardMsg", params);

export const getWifiCustomizationCardQueryCardMsgV2 = (params: any) =>
  https.get("/wifi/customization/card/queryCardMsgV2", params);

export const getWifiCustomizationCardQueryCardRealNameStatus = (params: any) =>
  https.get(`/wifi/customization/card/queryCardRealNameStatus`, params);

export const getWifiCustomizationCardChooseBestNet = (params: any) =>
  https.get(`/wifi/customization/card/chooseBestNet`, params);

export const getWifiCustomizationCardSendCode = (params: any) =>
  https.get(`/wifi/customization/card/send/code`, params);

export const getWifiCustomizationCardCheckCode = (params: any) =>
  https.get("/wifi/customization/card/check/code", params);

export const getWifiCustomizationCardRealName = (params: any) =>
  https.get("/wifi/customization/card/real/name", params);

export const getWifiCustomizationCardRealNameUrl = (params: any) =>
  https.get("/wifi/customization/card/real/name/url", params);

export const getWifiCustomizationCardFamilyNumber = (params: any) =>
  https.get("/wifi/customization/card/familyNumber", params);

export const postWifiCustomizationCardFamilyNumberAdd = (data: any) =>
  https.post("/wifi/customization/card/familyNumber/add", data);

export const postWifiCustomizationCardFamilyNumberConfirm = (data: any) =>
  https.post("/wifi/customization/card/familyNumber/confirm", data);

//套餐列表
export const getAgentPackageList = (data: any) =>
  https.get(
    `/wifi/customization/card/queryAgentPackageList?iccid=` +
      data.iccid +
      `&dayCode=` +
      data.dayCode
  );
//提交订单
export const postOrderPackage = (data: any) =>
  https.post("/wifi/customization/card/orderPackage", data);
//二次支付
export const getAgainOrder = (params: any) =>
  https.get("/wifi/customization/card/order/again", params);
//取消二次支付
export const getCloseAgainOrder = (params: any) =>
  https.get("/wifi/customization/card/order/close", params);

// 手表套餐列表
export const getAgentPackageListV2 = (params: any) =>
    https.get("/wifi/customization/card/queryAgentPackageListV2", params);

// 手表订购记录
export const getOrderList = (params: any) =>
  https.get("/wifi/customization/card/queryOrderList", params);

export const getTrainsUrl = (params: any) =>
  https.post("/wifi/customization/card/watches/jump", {}, { params });

export const getTrainsUrlV2 = (params: any) =>
  https.post("/wifi/customization/card/watches/customer-service/jump", {}, { params });

// 校验验证码
export const getCheckCode = (params: any) =>
  https.get("/wifi/customization/card/simpleCheck/code", params);

// 获取手表可订购体验包
export const getWatchExperienceInfo = (params: any) =>
  https.get("/wifi/customization/card/getWatchExperienceInfo", params);

// 订购体验包
export const postOrderExperience = (data: any) =>
  https.post("/wifi/customization/card/orderWatchExperience", data);
